function main(data) {
  let products = {};

  if (data) {
    for (let device of data) {
      const po = device?.productOffering;
      const title = device?.name;
      const price = device?.price;

      products[po] = {
        count: 0,
        title: {
          text: title,
        },
        price: price,
      };
    }
  }

  return products;
}

export default main;
